import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PricingPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-12">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Simple, Transparent Pricing
                    </h1>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        No hidden fees. No long-term contracts. Just one simple plan to help you grow.
                    </p>
                </div>

                <div className="max-w-lg mx-auto">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="bg-white rounded-2xl shadow-xl overflow-hidden border border-blue-100"
                    >
                        <div className="bg-blue-600 p-8 text-center text-white">
                            <h3 className="text-2xl font-bold mb-2">Pro Plan</h3>
                            <div className="flex justify-center items-baseline mb-4">
                                <span className="text-5xl font-bold">$29</span>
                                <span className="text-blue-100 ml-2">/month</span>
                            </div>
                            <p className="text-blue-100">Everything you need to manage your business.</p>
                        </div>

                        <div className="p-8">
                            <ul className="space-y-4 mb-8">
                                {[
                                    "Unlimited Quotes & Invoices",
                                    "Client & Lead Management",
                                    "Appointment Scheduling",
                                    "Public Booking Form",
                                    "Email Automation",
                                    "Gmail Integration",
                                    "Digital Signatures",
                                    "Priority Support"
                                ].map((item, idx) => (
                                    <li key={idx} className="flex items-center text-gray-700">
                                        <svg className="w-5 h-5 text-green-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <Link to="/register" className="block w-full">
                                <button className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-colors shadow-lg">
                                    Start 14-Day Free Trial
                                </button>
                            </Link>
                            <p className="text-center text-sm text-gray-500 mt-4">
                                No credit card required for trial. Cancel anytime.
                            </p>
                        </div>
                    </motion.div>
                </div>

                <div className="mt-20 max-w-3xl mx-auto">
                    <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Frequently Asked Questions</h2>
                    <div className="space-y-6">
                        {[
                            {
                                q: "Do I need a credit card to sign up?",
                                a: "No! You can start your 14-day free trial without entering any payment information."
                            },
                            {
                                q: "Can I cancel anytime?",
                                a: "Yes, there are no long-term contracts. You can cancel your subscription at any time from your account settings."
                            },
                            {
                                q: "Is my data secure?",
                                a: "Absolutely. We use industry-standard encryption to protect your data and your clients' information."
                            }
                        ].map((faq, idx) => (
                            <div key={idx} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">{faq.q}</h3>
                                <p className="text-gray-600">{faq.a}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingPage;
